import type { RootState } from '@/rootState';

export const getChatMessages = ({ aiTutorChatReducer }: RootState) => aiTutorChatReducer.messages;

export const getShowChat = ({ aiTutorChatReducer }: RootState) => aiTutorChatReducer.showChat;

export const getChatHistoryLoading = ({ aiTutorChatReducer }: RootState) =>
	aiTutorChatReducer.historyLoading;

export const getChatSending = ({ aiTutorChatReducer }: RootState) => aiTutorChatReducer.sending;

export const getChatLastEvaluatedKey = ({ aiTutorChatReducer }: RootState) =>
	aiTutorChatReducer.lastEvaluatedKey;

export const getChatMessageCounter = ({ aiTutorChatReducer }: RootState) =>
	aiTutorChatReducer.messageCounter;

export const getChatMessageObj = ({ aiTutorChatReducer }: RootState) =>
	aiTutorChatReducer.messageObj;

export const getChatConversationData = ({ aiTutorChatReducer }: RootState) =>
	aiTutorChatReducer.conversationData;
